import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-hlist3",
  "use": "icon-hlist3-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-hlist3\"><path d=\"M115.1 66.24c-13.96 0-25.59 4.65-34.9 13.96-9.31 9.31-13.96 20.94-13.96 34.9 0 88.41 13.57 174.87 40.72 259.4 27.14 84.53 67.08 162.47 119.81 233.81l69.79-69.79c-18.61-26.37-35.67-55.06-51.18-86.08L354.73 343.1c13.96-13.96 17.84-31.02 11.63-51.19-18.61-55.83-27.92-114.77-27.92-176.81 0-13.96-4.66-25.59-13.96-34.9-9.31-9.31-20.94-13.96-34.9-13.96H115.1z m804.97-25.59L40.65 920.07l62.81 65.14 244.28-241.96c76 69.8 162.85 123.31 260.57 160.53 97.71 37.22 198.53 55.83 302.44 55.83 13.96 0 25.59-4.65 34.9-13.96 9.3-9.31 13.96-20.94 13.96-34.9V736.27c0-13.96-4.65-25.59-13.96-34.9-9.31-9.31-20.94-13.96-34.9-13.96-62.04 0-120.98-9.31-176.81-27.92-20.16-6.21-37.22-2.33-51.18 11.63L573.42 780.48c-55.84-27.92-107.79-64.37-155.88-109.35l567.67-567.66-65.14-62.82z\" p-id=\"26301\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-hlist3.svg
// module id = za+b
// module chunks = 120